import vsdcFailedRequestsService from "../../../apis/services/admin/vsdcFailedRequestsService";
import {
  FETCH_VSDC_FAILED_REQUESTS_ATTEMPT,
  FETCH_VSDC_FAILED_REQUESTS_SUCCESS,
  FETCH_VSDC_FAILED_REQUESTS_ERROR,
  CLEAR_VSDC_FAILED_REQUESTS_ATTEMPT,
  CLEAR_VSDC_FAILED_REQUESTS_SUCCESS,
  CLEAR_VSDC_FAILED_REQUESTS_ERROR,
  CLEAR_VSDC_FAILED_REQUESTS_RESET_STATE,
  FETCH_TEST_DEVICES_ATTEMPT,
  FETCH_TEST_DEVICES_SUCCESS,
  FETCH_TEST_DEVICES_ERROR,
  SUBMIT_TEST_INVOICE_ATTEMPT,
  SUBMIT_TEST_INVOICE_SUCCESS,
  SUBMIT_TEST_INVOICE_ERROR,
  SUBMIT_TEST_INVOICE_RESET_STATE,
} from "../../actionTypes/actionTypes";

export const fetchVsdcFailedRequests = (limit = 100) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_VSDC_FAILED_REQUESTS_ATTEMPT });
    try {
      const response = await vsdcFailedRequestsService.getFailedRequests(limit);
      dispatch({
        type: FETCH_VSDC_FAILED_REQUESTS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_VSDC_FAILED_REQUESTS_ERROR,
        payload: error,
      });
    }
  };
};

export const clearVsdcFailedRequests = () => {
  return async (dispatch) => {
    dispatch({ type: CLEAR_VSDC_FAILED_REQUESTS_ATTEMPT });
    try {
      const response = await vsdcFailedRequestsService.clearFailedRequests();
      dispatch({
        type: CLEAR_VSDC_FAILED_REQUESTS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: CLEAR_VSDC_FAILED_REQUESTS_ERROR,
        payload: error,
      });
    }
  };
};

export const clearVsdcFailedRequestsResetState = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_VSDC_FAILED_REQUESTS_RESET_STATE });
  };
};

export const fetchTestDevices = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_TEST_DEVICES_ATTEMPT });
    try {
      const response = await vsdcFailedRequestsService.getTestDevices();
      dispatch({
        type: FETCH_TEST_DEVICES_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_TEST_DEVICES_ERROR,
        payload: error,
      });
    }
  };
};

export const submitTestInvoice = (invoiceData) => {
  return async (dispatch) => {
    dispatch({ type: SUBMIT_TEST_INVOICE_ATTEMPT });
    try {
      const response = await vsdcFailedRequestsService.submitTestInvoice(invoiceData);
      dispatch({
        type: SUBMIT_TEST_INVOICE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: SUBMIT_TEST_INVOICE_ERROR,
        payload: error,
      });
    }
  };
};

export const submitTestInvoiceResetState = () => {
  return (dispatch) => {
    dispatch({ type: SUBMIT_TEST_INVOICE_RESET_STATE });
  };
};

